import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { Box, Button, Flex, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const Carousel = ({ children, items, itemLabel = 'Item' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPreviousItem = () => {
    setCurrentIndex(prevIndex => (prevIndex === 0 ? items.length - 1 : prevIndex - 1));
  };

  const goToNextItem = () => {
    setCurrentIndex(prevIndex => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <Box>
      <VStack alignItems="center" justifyContent="center">
        <HStack>
          <Button leftIcon={<Icon as={FaChevronLeft} />} size="sm" variant="ghost" onClick={goToPreviousItem}>
            Previous
          </Button>
          <Button rightIcon={<Icon as={FaChevronRight} />} size="sm" variant="ghost" onClick={goToNextItem}>
            Next
          </Button>
        </HStack>
        <Box maxW="100%" p={4}>
          {items.map((item, index) => (
            <Box display={index === currentIndex ? 'block' : 'none'} key={item.id || index}>
              {children({ item })}
            </Box>
          ))}
        </Box>
      </VStack>
      <Text mt={2} textAlign="center">
        {itemLabel}
        {' '}
        {currentIndex + 1}
        {' '}
        of
        {' '}
        {items.length}
      </Text>
    </Box>
  );
};

Carousel.propTypes = {
  itemLabel: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({}))
};

export default Carousel;
